import React from "react";

export const renderLegalContent = (rawContent: string) => {
  if (!rawContent) return null;

  // Clean empty headers/paragraphs at the start (e.g. <h1><br></h1>)
  const cleaned = rawContent
    .replace(/^(\s*<h[1-6]>\s*(<br\s*\/?>)?\s*<\/h[1-6]>)+/i, "")
    .replace(/^(\s*<p>\s*(<br\s*\/?>)?\s*<\/p>)+/i, "");

  const hasHtml = /<[a-z][\s\S]*>/i.test(cleaned);

  if (hasHtml) {
    return (
      <div
        className="legal-content-body text-neutral-800 text-sm leading-relaxed"
        dangerouslySetInnerHTML={{ __html: cleaned }}
      />
    );
  }

  return (
    <div className="text-neutral-800 text-sm leading-relaxed whitespace-pre-wrap font-sans">
      {cleaned}
    </div>
  );
};

export const formatDocType = (type: string): string => {
  switch (type) {
    case "TERMS_AND_CONDITIONS":
      return "Terms & Conditions";
    case "PRIVACY_POLICY":
      return "Privacy Policy";
    case "MEDICAL_DISCLAIMER":
      return "Medical Disclaimer";
    default:
      return type.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  }
};

export const formatLegalDate = (dateStr: string | null | undefined): string => {
  if (!dateStr) return "N/A";
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return String(dateStr);
    return d.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return String(dateStr);
  }
};
